"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeSlice = void 0;
var numeric_1 = require("../../functions/numeric");
/** @internal */
var safeSlice = function (array, start, end) {
    var startClamped = (0, numeric_1.clamp)(0, array.length)(start);
    var endClamped = (0, numeric_1.clamp)(startClamped, array.length)(end);
    return array.slice(startClamped, endClamped);
};
exports.safeSlice = safeSlice;
